import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, forwardRef, Provider, EventEmitter } from '@angular/core';
import { UtilService } from '../../shared/util/util.service';
import { LogService } from '../../shared/log/log.service';

@Component({
  selector: 'wl-admin-settings',
  templateUrl: 'admin-settings.component.html',
    standalone: false
})
export class AdminSettingsComponent implements OnInit {
  private _logService: LogService;
  private _utilService: UtilService;

  public hasVerboseLogging: boolean;

  public constructor(utilService: UtilService, logService: LogService) {
    this._logService = logService;
    this._utilService = utilService;

    this.hasVerboseLogging = this._logService.VerboseLogging();
  }
  ngOnInit(): void {}

  public verboseLoggingChanged = (value: boolean): void => {
    if (value == true) {
      this._logService.enableVerboseLogging();
      this.hasVerboseLogging = true;
    } else {
      this._logService.disableVerboseLogging();
      this.hasVerboseLogging = false;
    }
  };
}
